import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'ApiRequestDrawer' }

import { computed, watch, onBeforeUnmount, getCurrentInstance } from 'vue'
import { formatGroupDate, formatGroupTime } from '@/plugins/dates'
import { tagChipStyle } from '@/util/tagChip'
import { statusClass, STATUS_LABELS, STATUS_COLORS, parseQueryParams, formatBody } from '@/util/apiRequestLog'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  show: { type: Boolean, default: false },
  request: { type: Object as () => Record<string, any> | null, default: null },
  // True while the page is fetching this row's request and response bodies.
  bodiesLoading: { type: Boolean, default: false },
  // Every key the company has had: [{ id, api_id, status }]
  keys: { type: Array as () => Array<Record<string, any>>, default: () => [] },
},
  emits: ['update:show', 'close'],
  setup(__props, { emit }) {

const props = __props

// Read-only detail of one Community API request (a row of api_request_log).




const { proxy } = getCurrentInstance() as any

const statusKind = computed(() => statusClass(props.request ? props.request.status : null))
const statusLabel = computed(() => STATUS_LABELS[statusKind.value])
const statusColor = computed(() => STATUS_COLORS[statusKind.value])

const timeText = computed(() => {
  if (!props.request) return ''
  return formatGroupDate(props.request.created_at) + ', ' + formatGroupTime(props.request.created_at)
})

const params = computed(() => parseQueryParams(props.request ? props.request.query_params : null))
const paramKeys = computed(() => Object.keys(params.value))

// Bodies arrive masked from the server: customer and card fields are starred before they are stored.
const requestBodyText = computed(() => formatBody(props.request ? props.request.request_body : null))
const responseBodyText = computed(() => formatBody(props.request ? props.request.response_body : null))

const keyLabel = computed(() => {
  const id = props.request ? props.request.api_key_id : null
  if (id === null || id === undefined) return 'Not recorded'
  const key = props.keys.find(k => Number(k.id) === Number(id))
  if (!key) return 'Not recorded'
  return key.api_id + (Number(key.status) === 1 ? '' : ' (rolled)')
})

function copy(text: string) {
  navigator.clipboard.writeText(text)
  proxy.$notify({ type: 'success', message: 'Copied to clipboard', icon: 'tim-icons icon-check-2' })
}

function onClose() {
  emit('update:show', false)
  emit('close')
}

function onEscKey(e: KeyboardEvent) {
  if (e.key === 'Escape') onClose()
}

watch(() => props.show, (visible) => {
  if (visible) document.addEventListener('keydown', onEscKey)
  else document.removeEventListener('keydown', onEscKey)
}, { immediate: true })

onBeforeUnmount(() => {
  document.removeEventListener('keydown', onEscKey)
})

return { __sfc: true,props, emit, proxy, statusKind, statusLabel, statusColor, timeText, params, paramKeys, requestBodyText, responseBodyText, keyLabel, copy, onClose, onEscKey, tagChipStyle }
}

})